export const InventoryLogo = ({
  width = "30",
  height = "30",
  fill = "none",
  color = "white",
}) => (
  <svg 
    width={width}
    height={height}
    fill={fill} 
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "5px" }}
  >
    <path 
      d="M18.3333 8.00004C18.3333 8.00004 17.5059 8.74231 15.851 9.40427L13.5106 10.3404C11.8557 11.0024 11.0282 11.3334 10 11.3334C8.97178 11.3334 8.14432 11.0024 6.48942 10.3404L4.14903 9.40427C2.49412 8.74231 1.66667 8.00004 1.66667 8.00004M18.3333 11.3334C18.3333 11.3334 17.5059 12.0756 15.851 12.7376L13.5106 13.6738C11.8557 14.3357 11.0282 14.6667 10 14.6667C8.97178 14.6667 8.14432 14.3357 6.48942 13.6738L4.14903 12.7376C2.49412 12.0756 1.66667 11.3334 1.66667 11.3334M13.5106 7.0071L15.851 6.07094C17.5059 5.40898 18.3333 5.078 18.3333 4.66671C18.3333 4.25542 17.5059 3.92444 15.851 3.26247L13.5106 2.32632C11.8557 1.66436 11.0282 1.33337 10 1.33337C8.97178 1.33337 8.14432 1.66436 6.48942 2.32632L4.14903 3.26247C2.49412 3.92444 1.66667 4.25542 1.66667 4.66671C1.66667 5.078 2.49412 5.40898 4.14903 6.07094L6.48942 7.0071C8.14432 7.66906 8.97178 8.00004 10 8.00004C11.0282 8.00004 11.8557 7.66906 13.5106 7.0071Z"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
    />
  </svg>
)